import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabsItemComponent } from './tabs-item/tabs-item.component';
import { TabsComponent } from './tabs.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { TooltipModule } from '../tooltip/tooltip.module';

@NgModule({
  declarations: [TabsItemComponent, TabsComponent],
  exports: [TabsItemComponent, TabsComponent],
  entryComponents: [TabsItemComponent, TabsComponent],
  imports: [TooltipModule, CommonModule, AngularSvgIconModule]
})
export class TabsModule {}

export * from './tabs-mode.enum';

export { TabsComponent, TabsItemComponent };
